export const templateVariables = Object.freeze({
  MUDLINE_DEPTH: 'MUDLINE_DEPTH',
  WELLHEAD_DEPTH: 'WELLHEAD_DEPTH',
  HOLE_SIZE: 'HOLE_SIZE',
  CASING_SIZE: 'CASING_SIZE',
  FROM_DEPTH: 'FROM_DEPTH',
  TO_DEPTH: 'TO_DEPTH',
});
